var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMiniRefrigirator(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#898B91",
    d: "M17.667 14.167c.184 0 .333.149.333.333v3.833A1.667 1.667 0 0116.333 20H7.667A1.667 1.667 0 016 18.333V14.5c0-.184.15-.333.333-.333zM14.333 15.5H9.667a.5.5 0 100 1h4.666a.5.5 0 100-1zm2-11.5C17.253 4 18 4.746 18 5.667v7.166c0 .184-.15.334-.333.334h-4.834a.333.333 0 01-.333-.334v-8.5c0-.184.15-.333.333-.333zm-5.166 0c.184 0 .333.15.333.333v8.5c0 .184-.15.334-.333.334H6.333A.333.333 0 016 12.833V5.667C6 4.747 6.746 4 7.667 4zm3.166 2.833a.5.5 0 00-.5.5v3.334a.5.5 0 001 0V7.333a.5.5 0 00-.5-.5zm-4.666 0a.5.5 0 00-.5.5v3.334a.5.5 0 101 0V7.333a.5.5 0 00-.5-.5z"
  })));
}
export default SvgMiniRefrigirator;